import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-loading',
  templateUrl: './shared-loading.component.html'
})
export class SharedLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
